import { UploadFileIcons } from "../../assets/icons/addFile";
import "./FileUploadSection.scss";

const FileUploadSection = ({ handleUpload, acceptType }) => {
  return (
    <div className="file-upload-section">
      <UploadFileIcons fillColor="var(--archeo-color)" />
      <div className="file-upload-content">
        <div className="">
          <label className="file-upload-browse-button" htmlFor="cassette-image">
            Cerca file
          </label>
          <input
            id="cassette-image"
            hidden
            type="file"
            onChange={handleUpload}
            accept={acceptType}
            multiple
          />
        </div>
        <p className="file-upload-info">
          I formati accettati sono {acceptType}. <br />
          massima dimensione di upload: 3 mb
        </p>
      </div>
    </div>
  );
};

export default FileUploadSection;
